import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-filters__actions gfu-filters__actions--fixed"
}
const _hoisted_2 = {
  class: "gfu-filters__list",
  "data-qa": "filtersbox-edit-filters"
}
const _hoisted_3 = {
  class: "gfu-balloon__content",
  "data-qa": "filtersbox-filters-selection-balloon"
}
const _hoisted_4 = { class: "gfu-filters__body" }
const _hoisted_5 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_6 = { class: "gfu-filters__actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")
  const _component_icon_base_button = _resolveComponent("icon-base-button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-filters', { 'gfu-filters--collapsed': !$data.isExpanded }]),
    "data-qa": "filters-box"
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggle && $options.toggle(...args))),
      "data-qa": "filters"
    }, [
      _createElementVNode("h2", {
        class: _normalizeClass(['gfu-filters__caption gfu-heading gfu-heading--main', { 'gfu-filters__caption--expanded': $data.isExpanded }])
      }, [
        _createVNode(_component_base_icon, {
          name: $data.isExpanded ? 'chevron-down' : 'chevron-right',
          class: "gfu-filters__caption-icon"
        }, null, 8 /* PROPS */, ["name"]),
        _cache[2] || (_cache[2] = _createTextVNode("Filters ", -1 /* CACHED */))
      ], 2 /* CLASS */),
      ($data.optionalFilters.length)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_toggle_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_toggle_trigger, {
                    tag: "a",
                    href: "",
                    class: "gfu-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "filter" }),
                      _cache[3] || (_cache[3] = _createTextVNode(" add/remove filter", -1 /* CACHED */))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_toggle_content, {
                    tag: "div",
                    tabindex: "0",
                    class: "gfu-balloon gfu-balloon--right gfu-balloon--no-header gfu-table__dropdown is-hidden",
                    "active-class": "is-open"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionalFilters, (filter, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `filter-${index}`,
                            class: "gfu-balloon__item"
                          }, [
                            _createVNode(_component_checkbox_field, {
                              modelValue: filter.componentInstance.isVisible,
                              "onUpdate:modelValue": $event => ((filter.componentInstance.isVisible) = $event),
                              class: _normalizeClass({'_mt-0': index === 0}),
                              condensed: true,
                              "data-qa": `filters-list-checkbox:${filter.componentInstance.displayName}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(filter.componentInstance.displayName), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "class", "data-qa"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ], 512 /* NEED_PATCH */)), [
            [_vShow, $data.isExpanded]
          ])
        : _createCommentVNode("v-if", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createCommentVNode(" Filter fields go here ")
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $data.isExpanded]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-filters__reset",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.reset && $options.reset(...args)), ["prevent"])),
        "data-qa": "filtersbox-filters-selection-reset"
      }, [
        _createVNode(_component_base_icon, { name: "undo" }),
        _cache[4] || (_cache[4] = _createTextVNode(" reset", -1 /* CACHED */))
      ]),
      _createVNode(_component_icon_base_button, {
        icon: "filter",
        theme: "accent",
        enabled: $options.isApplyFiltersActionEnabled,
        onClick: $options.onApplyFilters,
        "data-qa": "filtersbox-filters-selection-apply"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("apply filter", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $data.isExpanded]
    ])
  ], 2 /* CLASS */))
}